export default __webpack_public_path__ + "static/media/aged_person.e82156db.png";